import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-center font-medium -mt-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spinner" }, [
            _createElementVNode("div", { class: "dot1" }),
            _createElementVNode("div", { class: "dot2" })
        ], -1)),
        (_ctx.message)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.message), 1))
            : _createCommentVNode("", true)
    ]));
}
